import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ClassifierTree/nodes/DynamicGeneratedGroupContent/DynamicGeneratedGroupContent.tsx";
import "core-js/modules/es.function.name.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { NodeMoreActionButton } from '@gmini/ui-kit';
import { useHover } from '@gmini/utils';
import { NumCycleContainer } from "../../../../components";
import { NodeLayout } from "../../NodeLayout";
import { NodeExpand } from "../../../NodeExpand";
import { useNodeCtxMenu } from "../../TreeContextMenu/ctx";
import { NodeCheckbox } from "../../NodeCheckbox";
import { getStyle } from "../../../Common/getStyle";
import { getGroupPendingKey } from "../../model/pendingModel";
import { getIconByDynamicInfo, useDynamicInfo } from "./utils";
import { jsx as _jsx } from "react/jsx-runtime";
export var DynamicGeneratedGroupContent = function DynamicGeneratedGroupContent(_ref) {
  var path = _ref.path,
      checkbox = _ref.checkbox,
      isExpanded = _ref.isExpanded,
      node = _ref.node,
      onClickNode = _ref.onClickNode,
      onDoubleClickNode = _ref.onDoubleClickNode,
      onExpandClick = _ref.onExpandClick,
      isSelected = _ref.isSelected,
      RenderNodeLayout = _ref.renderNodeLayout,
      onCheckedNode = _ref.onCheckedNode,
      onPending = _ref.onPending,
      inSearch = _ref.inSearch,
      highlighted = _ref.highlighted,
      treeItem = _ref.treeItem,
      dependencyData = _ref.dependencyData,
      onSearchSource = _ref.onSearchSource;

  var _useNodeCtxMenu = useNodeCtxMenu({
    path: path
  }),
      onContextMenu = _useNodeCtxMenu.onContextMenu,
      open = _useNodeCtxMenu.open,
      onClickOpen = _useNodeCtxMenu.onClickOpen;

  var matched = inSearch.matched,
      fullMatch = inSearch.fullMatch;

  var _useHover = useHover(),
      onMouseLeave = _useHover.onMouseLeave,
      onMouseOver = _useHover.onMouseOver,
      hover = _useHover.hover;

  var deepness = path.length - 1;
  var expandable = 'total' in node && node.total > 0;
  var highlightedInSearch = false;

  if (matched) {
    if (fullMatch) {
      highlightedInSearch = true;
    } else if (!isExpanded) {
      highlightedInSearch = true;
    }
  }

  if (fullMatch || highlighted) {
    highlightedInSearch = true;
  }

  var style = getStyle({
    highlightedInSearch: highlightedInSearch,
    hover: open || hover,
    isSelected: isSelected
  });
  var dynamicInfo = useDynamicInfo({
    node: node,
    path: path
  });
  var icon = getIconByDynamicInfo(dynamicInfo);
  var textColor = style.color;

  var checkboxJsx = /*#__PURE__*/_jsx(NodeCheckbox, _objectSpread(_objectSpread({}, checkbox), {}, {
    onChange: function onChange(_, value) {
      return onCheckedNode(value);
    }
  })); // Virtual standard size


  if (dynamicInfo.sourceType === 'BimStandardSize' && !dynamicInfo.hasParentConditions) {
    textColor = 'rgba(0, 3, 53, 0.4)';
    checkboxJsx = null;
  }

  var nodeLayoutProps = {
    icon: icon,
    text: node.name,
    onClick: onClickNode,
    onDoubleClick: onDoubleClickNode,
    onExpand: onExpandClick,
    onContextMenu: onContextMenu,
    onMouseLeave: onMouseLeave,
    onMouseOver: onMouseOver,
    expandJsx: /*#__PURE__*/_jsx(NodeExpand, {
      onClick: onExpandClick,
      expanded: isExpanded,
      hidden: !expandable,
      hovered: hover
    }),
    checkbox: checkboxJsx,
    // TODO вынести наверх либо в функцию для избавления от копипасты
    deepness: deepness,
    style: _objectSpread({}, style),
    textStyle: {
      color: textColor
    },
    pending: onPending(getGroupPendingKey(node)),
    //TODO pendingMap refactor,
    numCycle: dependencyData && /*#__PURE__*/_jsx(NumCycleContainer, {
      dependencyData: dependencyData,
      onSearchSource: onSearchSource
    }),
    endContent: /*#__PURE__*/_jsx(NodeMoreActionButton, {
      show: hover || open,
      active: open,
      onClick: onClickOpen
    })
  };

  if (RenderNodeLayout) {
    return RenderNodeLayout({
      node: node,
      nodeLayoutProps: nodeLayoutProps,
      path: path,
      treeItem: treeItem
    });
  }

  return /*#__PURE__*/_jsx(NodeLayout, _objectSpread({}, nodeLayoutProps));
};